import styled from 'styled-components';

const PortfolioListSkeletonStyle = styled.section`
	--maxWidth: 74.2%;
	--itemMarg: var(--sp13x);
	--itemDistance: var(--sp25x);
	--itemWidth: calc(50% - (var(--itemMarg) / 2));

	max-width: var(--maxWidth);
	display: flex;
	flex-wrap: wrap;
	margin: 0 auto;
	margin-top: var(--titleToContent);
	margin-bottom: var(--sectionToSection);

	.portfolio-skeleton-block {
		width: var(--itemWidth);
		height: fit-content;
		margin-bottom: var(--itemDistance);

		&:nth-child(2n) {
			margin-left: calc(var(--itemMarg) / 2);
		}

		&:nth-child(2n-1) {
			margin-right: calc(var(--itemMarg) / 2);
		}

		&:nth-child(6n-1),
		&:nth-child(6n-3) {
			svg {
				margin-top: -61%;
			}
		}

		&:last-child,
		&:nth-last-child(2) {
			margin-bottom: 0;
		}
	}

	svg {
		width: 100%;
		height: auto;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) {
		--maxWidth: 79.3%;
		--itemDistance: var(--sp20x);
	}

	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) {
		--maxWidth: 950px;
		--itemMarg: var(--sp9x);
		--itemDistance: var(--sp15x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) {
		--itemDistance: var(--sp12x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) {
		--maxWidth: 83%;
		--itemMarg: var(--sp4x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--maxWidth: 100%;
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--maxWidth: 100%;
		--itemWidth: 100%;
		--itemDistance: var(--sp8x);

		.portfolio-skeleton-block {
			&:nth-child(2n) {
				margin-left: 0;
			}

			&:nth-child(2n-1) {
				margin-right: 0;
			}

			&:nth-child(6n-1),
			&:nth-child(6n-3) {
				svg {
					margin-top: 0;
				}
			}

			&:nth-last-child(2) {
				margin-bottom: var(--itemDistance);
			}
		}
	}
`;

export default PortfolioListSkeletonStyle;
